"use strict";

var _types = require("./types");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DEFAULT_CONFIGURATION_DATA = exports.DEFAULT_CLIENT_CONFIGURATION = void 0;
var DEFAULT_CONFIGURATION_DATA = exports.DEFAULT_CONFIGURATION_DATA = {
    customData: [],
    configuration: {
      realTimeUpdate: !1,
      consentType: _types.ConsentType.NotRequired,
      dataApiDomain: "data.kameleoon.io"
    }
  },
  DEFAULT_CLIENT_CONFIGURATION = exports.DEFAULT_CLIENT_CONFIGURATION = {
    customData: [],
    featureFlags: [],
    configuration: {
      realTimeUpdate: !1,
      consentType: _types.ConsentType.NotRequired,
      dataApiDomain: "data.kameleoon.io"
    }
  };